// extracted by mini-css-extract-plugin
export default {"wrapper":"l9gCWZ","mobile":"vMB2aj","desktop":"TkBBYp"};